
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/booking/voucher/[purchaseId]",
      function () {
        return require("private-next-pages/booking/voucher/[purchaseId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/booking/voucher/[purchaseId]"])
      });
    }
  